import { render, staticRenderFns } from "./MarketFee.vue?vue&type=template&id=8b81a6be&"
import script from "./MarketFee.vue?vue&type=script&lang=js&"
export * from "./MarketFee.vue?vue&type=script&lang=js&"
import style0 from "./MarketFee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MarketFee.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/MarketFee.vue
// module id = null
// module chunks = 